import { isTokenExpired } from '../../utils/helpers'

export const PARTNER_AUTH_TOKEN_KEY = 'partnerAuthToken'
export const PARTNER_DATA_KEY = 'partner_data'

export type PartnerSession = {
  userId: number
  name: string
  email: string
  role: string
  referralCode: string
  passwordResetUsed: boolean
}

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0'])

export const partnerLoginRequiresRecaptcha = () => {
  if (typeof window === 'undefined') return false
  return !LOCAL_HOSTS.has(window.location.hostname)
}

export const setPartnerSession = (token: string, data: PartnerSession) => {
  sessionStorage.setItem(PARTNER_AUTH_TOKEN_KEY, token)
  sessionStorage.setItem(PARTNER_DATA_KEY, JSON.stringify(data))
}

export const getPartnerToken = () => sessionStorage.getItem(PARTNER_AUTH_TOKEN_KEY)

export const getPartnerSession = (): PartnerSession | null => {
  const raw = sessionStorage.getItem(PARTNER_DATA_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as PartnerSession
    if (!parsed || typeof parsed.email !== 'string' || typeof parsed.userId !== 'number') {
      return null
    }
    return {
      userId: parsed.userId,
      name: typeof parsed.name === 'string' ? parsed.name : '',
      email: parsed.email,
      role: typeof parsed.role === 'string' ? parsed.role : '',
      referralCode: typeof parsed.referralCode === 'string' ? parsed.referralCode : '',
      passwordResetUsed: parsed.passwordResetUsed === true,
    }
  } catch {
    return null
  }
}

export const clearPartnerSession = () => {
  sessionStorage.removeItem(PARTNER_AUTH_TOKEN_KEY)
  sessionStorage.removeItem(PARTNER_DATA_KEY)
}

export const markPartnerPasswordResetUsed = () => {
  const token = getPartnerToken()
  const session = getPartnerSession()
  if (!token || !session) return
  setPartnerSession(token, { ...session, passwordResetUsed: true })
}

export const hasActivePartnerSession = () => {
  const token = getPartnerToken()
  const session = getPartnerSession()
  if (!token || !session) return false

  try {
    if (isTokenExpired(token)) {
      clearPartnerSession()
      return false
    }
  } catch {
    clearPartnerSession()
    return false
  }

  return true
}

export const getPartnerHomePath = () => {
  if (!hasActivePartnerSession()) return '/partner'
  const session = getPartnerSession()
  if (!session?.passwordResetUsed) return '/partner/set-password'
  return '/partner/investors'
}
